<template>
  <div
    :class="{
      'input-module': true,
      error: error,
      disabled: disabled == 'true' || loading,
      simple: simple,
      saveButton: saveButton,
      plusButton: plusButton,
    }"
  >
    <div class="title" v-if="title">{{ title }}</div>

    <div v-if="type == 'text'">
      <input
        ref="type_text"
        class="text-input"
        type="text"
        v-model="valueLocal"
        @keydown="inputEvent"
        @click="inputEvent"
        @focus="inputEvent"
        :placeholder="placeholder"
        :disabled="disabled == 'true'"
      />
      <div
        v-if="emojis"
        :class="{ toggle_emoji_picker: true, openned: showEmojiPicker }"
        @click="emojiPickerToggle"
      >
        <i class="far fa-laugh"></i>
      </div>
      <div
        v-if="emojis"
        :class="{ emojipicker: true, hidden: !showEmojiPicker }"
      >
        <VEmojiPicker
          :showSearch="false"
          :emojiWithBorder="false"
          @select="emojiPickerSelect"
        />
      </div>
    </div>

    <div v-if="type == 'phone'">
      <input
        ref="type_text"
        class="text-input"
        type="text"
        v-model="valueLocal"
        @keydown="inputEvent"
        @click="inputEvent"
        @focus="inputEvent"
        :placeholder="placeholder || '+7 ___ ___ __ __'"
        :disabled="disabled == 'true'"
        v-mask="'+7 ### ### ## ##'"
      />
    </div>

    <div v-if="type == 'link'" class="link">
      <input
        class="link-input"
        type="text"
        v-model="valueLocal"
        placeholder="https://"
        :disabled="disabled == 'true'"
      />
      <!-- <div class='warning' v-if="!valueLocal.includes('http')">В ссылке не найден протокол.<br>Добавьте https:// или http://</div> -->
    </div>
    <div v-if="type == 'title-text'" class="title-text">
      <input
        class="text-input"
        type="text"
        v-model="valueLocal"
        @keydown="inputEvent"
        @click="inputEvent"
        @focus="inputEvent"
        :placeholder="placeholder"
        :disabled="disabled == 'true'"
      />
      <div
        v-if="emojis"
        :class="{ toggle_emoji_picker: true, openned: showEmojiPicker }"
        @click="emojiPickerToggle"
      >
        <i class="far fa-laugh"></i>
      </div>
      <div
        v-if="emojis"
        :class="{ emojipicker: true, hidden: !showEmojiPicker }"
      >
        <VEmojiPicker
          :showSearch="false"
          :emojiWithBorder="false"
          @select="emojiPickerSelect"
        />
      </div>
    </div>
    <div v-if="type == 'textarea'" class="textarea">
      <smart-textbox
        v-model="valueLocal"
        :disabled="disabled == 'true'"
        :emojis="emojis"
      />
    </div>
    <div v-if="type == 'image'" class="image-input-holder" ref="imageFileForm">
      <table>
        <tr>
          <td>
            <div class="transparency">
              <div
                class="image-input"
                :layout="layout"
                :style="{
                  backgroundImage: `url(${valueLocal})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }"
              ></div>
            </div>
          </td>
          <td>
            <button
              :class="{ styled: true, uploadButton: true }"
              :disabled="loading"
              @click="uploadImage"
            >
              <i class="far fa-upload"></i> Выбрать
            </button>
            <br />
            <button class="remove_image" @click="removeImage">
              Удалить изображение
            </button>
          </td>
        </tr>
      </table>
      <!-- <div class='row'>
              <div :class="layout?(layout=='square'?'col-1':(layout=='big'?'col-4':'')):'col-4'">
                  
              </div>
              <div class='col'>
              </div>
          </div> -->
      <input
        ref="fileUploadInput"
        type="file"
        class="input-module-hidden-input"
        @change="handleImageUpload"
      />
    </div>
    <div v-if="type == 'number'">
      <input
        ref="type_number"
        class="number-input"
        type="number"
        :step="step"
        v-model="valueLocal"
        :placeholder="placeholder"
        :disabled="disabled == 'true'"
      />
    </div>
    <div v-if="type == 'number-change-show'" class="number-change-show-holder">
      <input
        ref="type_number-change-show"
        class="number-input"
        type="number"
        :step="step"
        v-model="valueLocal"
        :placeholder="placeholder"
        :disabled="disabled == 'true'"
      />
      <div
        :class="{ change: true, positive: valueLocal - initValueLocal > 0 }"
        v-if="valueLocal - initValueLocal != 0"
      >
        {{ `${valueLocal - initValueLocal > 0 ? "+" : ""}`
        }}{{ valueLocal - initValueLocal }} {{ measure }}
      </div>
    </div>
    <div v-if="type == 'color'" class="color_holder">
      <verte picker="square" model="hex" v-model="valueLocal"></verte>
    </div>
    <div v-if="type == 'datetime'" class="datetime">
      <VueCtkDateTimePicker
        format="YYYY-MM-DD HH:mm"
        v-model="valueLocal"
        lang="ru"
        label="Выберите дату и время"
        style="width: calc(100% - 15px)"
        button-now-translation="Сейчас"
        :disabled="disabled == 'true'"
      />
    </div>
    <div v-if="type == 'code-css'">
      <prism-editor
        class="code"
        language="css"
        v-model="valueLocal"
      ></prism-editor>
    </div>
    <div v-if="type == 'code-html'">
      <prism-editor
        class="code"
        language="html"
        v-model="valueLocal"
      ></prism-editor>
    </div>
    <div v-if="type == 'code-js'">
      <prism-editor
        class="code"
        language="javascript"
        v-model="valueLocal"
      ></prism-editor>
    </div>
    <div v-if="type == 'smsfeedback-questions'" class="smsfeedback-questions">
      <div
        v-for="question in valueLocal"
        class="question"
        v-bind:key="question.id"
      >
        <input
          class="question-title"
          type="text"
          v-model="question.title"
          placeholder="Заголовок вопроса"
        />
        Тип вопроса:
        <select class="form-control" v-model="question.type">
          <option value="option">Выбор одного варианта из нескольких</option>
          <option value="checkbox">Выбор нескольких вариантов</option>
          <option value="text">Ввод собственного текста</option>
        </select>
        <button
          class="remove-question"
          @click="smsfeedbackQuestionRemove(question)"
        >
          <i class="fal fa-times"></i>
        </button>
        <div
          class="value-holder"
          v-if="question.type == 'option' || question.type == 'checkbox'"
        >
          <div class="value-header">Варианты ответов:</div>
          <button
            class="add_value"
            @click="smsfeedbackQuestionAddValue(question)"
          >
            <i class="fal fa-plus"></i>
          </button>
          <div
            v-for="(qv, i) in question.value"
            v-bind:key="question.id + '_' + qv"
            class="question-value"
          >
            <button
              class="remove-value"
              @click="smsfeedbackQuestionRemoveValue(question, i)"
            >
              <i class="fal fa-times"></i>
            </button>
            <span @click="smsfeedbackQuestionUpdateValue(question, i)">{{
              qv
            }}</span>
          </div>
        </div>
      </div>
      <button @click="smsfeedbackQuestionAdd()" class="styled question-add">
        Добавить вопрос
      </button>
    </div>
    <div v-if="type == 'cards-geofences'" class="cards-geofences">
      <div
        v-for="(v, i) in valueLocal"
        class="point"
        v-bind:key="'marker__' + i"
      >
        <div class="point_title">Точка №{{ i + 1 }}</div>
        <button class="remove_point" @click="geofenceRemoveMarker(i)">
          <i class="fal fa-times"></i>
        </button>
        <input class="point-text" type="text" v-model="v.relevantText" />
        <div class="row">
          <div class="col">
            Широта
            <input
              class="point-nav"
              type="text"
              v-model="v.latitude"
              @keyup="geoFenceLocationChanged('latitude', v)"
            />
          </div>
          <div class="col">
            Долгота
            <input
              class="point-nav"
              type="text"
              v-model="v.longitude"
              @keyup="geoFenceLocationChanged('longitude', v)"
            />
          </div>
        </div>
      </div>
      <button
        :disabled="valueLocal.length >= 10"
        @click="geofenceAddMarker"
        class="geofences-addpoint-withoutmap"
      >
        Добавить точку
      </button>
      <div
        @click="openGeoCollection()"
        :class="{ collection_toggle: true, showing: showCollection }"
      >
        <i class="far fa-book"></i>Мои пуши
      </div>
      <div @click="openGeoFenceMapPreview()" class="lookGeoFences">
        <i class="fas fa-eye"></i> Посмотреть на карте
      </div>
      <div class="collection" v-if="showCollection">
        <div class="title">Ваши геопуши</div>
        <div class="close" @click="openGeoCollection">
          <i class="fal fa-times"></i>
        </div>
        <div class="elList">
          <div
            :class="{
              el: true,
              used: valueLocal.find(
                (x) =>
                  x.relevantText == el.relevantText &&
                  x.longitude == el.longitude &&
                  x.latitude == el.latitude
              ),
            }"
            v-for="(el, i) in collection"
            :key="i"
            @click="addFromGeoCollection(el)"
          >
            <div class="text">{{ el.relevantText }}</div>
            <span class="coordinate">{{ el.latitude }}</span>
            <span class="coordinate">{{ el.longitude }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="type == 'cards-content'" class="cards-content">
      <div class="field" v-for="field of valueLocal" :key="field.key">
        <button
          class="remove-field"
          @click="cardsContentRemoveField(field)"
          :disabled="field.key == 'last_message' ? true : false"
        >
          <i class="fal fa-times"></i>
        </button>
        <input
          type="text"
          class="field-label"
          v-model="field.label"
          placeholder="Заголовок поля"
        />
        <div
          v-if="field.key == 'last_message'"
          style="
            position: relative;
            margin-bottom: 10px;
            display: block;
            cursor: default;
            z-index: 1;
            width: calc(100% - 15px);
            color: gray;
          "
        >
          {{ default_text[0] }}
        </div>
        <!-- <textarea-autosize class='field-value' v-model="field.value" :disabled="field.key=='last_message'?true:false"></textarea-autosize> -->
        <smart-textbox
          v-model="field.value"
          v-if="field.key != 'last_message'"
          :disabled="field.key == 'last_message' ? true : false"
          :emojis="true"
          examples="card-backfields"
        />
      </div>
      <button class="styled" @click="cardsContentAddField">
        Добавить поле
      </button>
    </div>
    <div
      v-if="type == 'cards-content-secondary'"
      class="cards-content-secondary"
    >
      <div class="unavailable_on_mobile">
        К сожалению, редактирование этого параметра недоступно на мобильном
        устройстве.
      </div>
      <table>
        <!-- header -->
        <tr>
          <td colspan="2">
            <div class="blank"><span>Здесь логотип</span></div>
          </td>
          <td>
            <div
              class="add_field"
              v-if="valueLocal.headerFields.length == 0"
              @click="openCardContentMarket(0, 'headerFields')"
            >
              <i class="fal fa-plus"></i>
              <span>Добавить</span>
            </div>
            <div
              class="current_field text-right"
              v-else
              @click="openFieldDetails(0, 'headerFields')"
            >
              <div
                v-if="
                  cardContentFields(valueLocal.headerFields[0]).key.slice(
                    0,
                    6
                  ) != 'spacer'
                "
              >
                <div class="key">
                  {{
                    cardContentFields(valueLocal.headerFields[0]).default_label
                  }}
                </div>
                <div class="value">
                  {{
                    cardContentFields(valueLocal.headerFields[0]).example_value
                  }}
                </div>
              </div>
              <div v-else class="add_field">
                <i class="fal fa-plus"></i>
                <span>Добавить</span>
              </div>
            </div>
          </td>
        </tr>
        <!-- primary -->
        <tr>
          <td v-if="valueLocal.primaryFields">
            <div
              class="add_field"
              v-if="valueLocal.primaryFields.length == 0"
              @click="openCardContentMarket(0, 'primaryFields')"
            >
              <i class="fal fa-plus"></i>
              <span>Добавить</span>
            </div>
            <div
              class="current_field text-left"
              v-else
              @click="openFieldDetails(0, 'primaryFields')"
            >
              <div
                v-if="
                  cardContentFields(valueLocal.primaryFields[0]).key.slice(
                    0,
                    6
                  ) != 'spacer'
                "
              >
                <div class="value big">
                  {{
                    cardContentFields(valueLocal.primaryFields[0]).example_value
                  }}
                </div>
                <div class="key">
                  {{
                    cardContentFields(valueLocal.primaryFields[0]).default_label
                  }}
                </div>
              </div>
              <div v-else class="add_field">
                <i class="fal fa-plus"></i>
                <span>Добавить</span>
              </div>
            </div>
          </td>
          <td colspan="2">
            <div class="blank">
              <span>Здесь стрип</span>
            </div>
          </td>
        </tr>
        <!-- secondary -->
        <tr v-if="valueLocal.secondaryFields.length == 0">
          <td>
            <div
              class="add_field"
              @click="openCardContentMarket(0, 'secondaryFields')"
            >
              <i class="fal fa-plus"></i>
              <span>Добавить</span>
            </div>
          </td>
          <td>
            <div
              class="add_field"
              @click="openCardContentMarket(1, 'secondaryFields')"
            >
              <i class="fal fa-plus"></i>
              <span>Добавить</span>
            </div>
          </td>
          <td>
            <div
              class="add_field"
              @click="openCardContentMarket(2, 'secondaryFields')"
            >
              <i class="fal fa-plus"></i>
              <span>Добавить</span>
            </div>
          </td>
        </tr>
        <tr v-if="valueLocal.secondaryFields.length == 1">
          <td>
            <div
              class="current_field text-left"
              @click="openFieldDetails(0, 'secondaryFields')"
            >
              <div
                v-if="
                  cardContentFields(valueLocal.secondaryFields[0]).key.slice(
                    0,
                    6
                  ) != 'spacer'
                "
              >
                <div class="key">
                  {{
                    cardContentFields(valueLocal.secondaryFields[0])
                      .default_label
                  }}
                </div>
                <div class="value">
                  {{
                    cardContentFields(valueLocal.secondaryFields[0])
                      .example_value
                  }}
                </div>
              </div>
              <div v-else class="add_field">
                <i class="fal fa-plus"></i>
                <span>Добавить</span>
              </div>
            </div>
          </td>
          <td>
            <div
              class="add_field"
              @click="openCardContentMarket(1, 'secondaryFields')"
            >
              <i class="fal fa-plus"></i>
              <span>Добавить</span>
            </div>
          </td>
          <td>
            <div
              class="add_field"
              @click="openCardContentMarket(2, 'secondaryFields')"
            >
              <i class="fal fa-plus"></i>
              <span>Добавить</span>
            </div>
          </td>
        </tr>
        <tr v-if="valueLocal.secondaryFields.length == 2">
          <td>
            <div
              class="current_field text-left"
              @click="openFieldDetails(0, 'secondaryFields')"
            >
              <div
                v-if="
                  cardContentFields(valueLocal.secondaryFields[0]).key.slice(
                    0,
                    6
                  ) != 'spacer'
                "
              >
                <div class="key">
                  {{
                    cardContentFields(valueLocal.secondaryFields[0])
                      .default_label
                  }}
                </div>
                <div class="value">
                  {{
                    cardContentFields(valueLocal.secondaryFields[0])
                      .example_value
                  }}
                </div>
              </div>
              <div v-else class="add_field">
                <i class="fal fa-plus"></i>
                <span>Добавить</span>
              </div>
            </div>
          </td>
          <td>
            <div
              class="add_field"
              @click="openCardContentMarket(1, 'secondaryFields')"
            >
              <i class="fal fa-plus"></i>
              <span>Добавить</span>
            </div>
          </td>
          <td>
            <div
              class="current_field text-right"
              @click="openFieldDetails(1, 'secondaryFields')"
            >
              <div
                v-if="
                  cardContentFields(valueLocal.secondaryFields[1]).key.slice(
                    0,
                    6
                  ) != 'spacer'
                "
              >
                <div class="key">
                  {{
                    cardContentFields(valueLocal.secondaryFields[1])
                      .default_label
                  }}
                </div>
                <div class="value">
                  {{
                    cardContentFields(valueLocal.secondaryFields[1])
                      .example_value
                  }}
                </div>
              </div>
              <div v-else class="add_field">
                <i class="fal fa-plus"></i>
                <span>Добавить</span>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="valueLocal.secondaryFields.length == 3">
          <td>
            <div
              class="current_field text-left"
              @click="openFieldDetails(0, 'secondaryFields')"
            >
              <div
                v-if="
                  cardContentFields(valueLocal.secondaryFields[0]).key.slice(
                    0,
                    6
                  ) != 'spacer'
                "
              >
                <div class="key">
                  {{
                    cardContentFields(valueLocal.secondaryFields[0])
                      .default_label
                  }}
                </div>
                <div class="value">
                  {{
                    cardContentFields(valueLocal.secondaryFields[0])
                      .example_value
                  }}
                </div>
              </div>
              <div v-else class="add_field">
                <i class="fal fa-plus"></i>
                <span>Добавить</span>
              </div>
            </div>
          </td>
          <td>
            <div
              class="current_field text-center"
              @click="openFieldDetails(1, 'secondaryFields')"
            >
              <div
                v-if="
                  cardContentFields(valueLocal.secondaryFields[1]).key.slice(
                    0,
                    6
                  ) != 'spacer'
                "
              >
                <div class="key">
                  {{
                    cardContentFields(valueLocal.secondaryFields[1])
                      .default_label
                  }}
                </div>
                <div class="value">
                  {{
                    cardContentFields(valueLocal.secondaryFields[1])
                      .example_value
                  }}
                </div>
              </div>
              <div v-else class="add_field">
                <i class="fal fa-plus"></i>
                <span>Добавить</span>
              </div>
            </div>
          </td>
          <td>
            <div
              class="current_field text-right"
              @click="openFieldDetails(2, 'secondaryFields')"
            >
              <div
                v-if="
                  cardContentFields(valueLocal.secondaryFields[2]).key.slice(
                    0,
                    6
                  ) != 'spacer'
                "
              >
                <div class="key">
                  {{
                    cardContentFields(valueLocal.secondaryFields[2])
                      .default_label
                  }}
                </div>
                <div class="value">
                  {{
                    cardContentFields(valueLocal.secondaryFields[2])
                      .example_value
                  }}
                </div>
              </div>
              <div v-else class="add_field">
                <i class="fal fa-plus"></i>
                <span>Добавить</span>
              </div>
            </div>
          </td>
        </tr>
      </table>
      <div class="element_editor" v-if="cardContentSelectedField.show">
        <div class="close" @click="cardContentSelectedField.show = false">
          <i class="fal fa-times"></i>
        </div>
        <div class="name">{{ cardContentSelectedField.name }}</div>
        <div class="key">{{ cardContentSelectedField.key }}</div>
        <div
          class="changeMessage"
          v-if="cardContentSelectedField.changeMessageEnabled"
        >
          <div class="title">Пуш при изменении:</div>
          <smart-textbox
            v-model="cardContentSelectedField.changeMessage"
            :emojis="true"
          />
          <div class="tip">%@ - Новое значение</div>
          <!-- <input type="text" v-model="cardContentSelectedField.changeMessage"> -->
        </div>
        <button class="remove" @click="removeSelectedField">
          Удалить поле
        </button>
      </div>
      <div class="element_market" v-if="cardContentMarket.show">
        <div class="close" @click="cardContentMarket.show = false">
          <i class="fal fa-times"></i>
        </div>
        <div
          class="element"
          v-for="e of Object.keys(cardContentKeys)"
          :key="e"
          @click="cardContentAddField(e)"
        >
          <i class="fal fa-plus-circle"></i>
          <div class="name">{{ cardContentKeys[e].name }}</div>
          <div class="key">{{ e }}</div>
        </div>
      </div>
    </div>
    <div v-if="type == 'cards-form-links'" class="cards-form-links">
      <button
        class="styled margin-right"
        :disabled="valueLocal.instagram ? true : false"
        @click="cardsFormLinkAdd('instagram')"
      >
        + Ссылка на Instagram
      </button>
      <button
        class="styled margin-right"
        :disabled="true"
        @click="cardsFormLinkAdd('vk')"
      >
        + Ссылка на VK
      </button>
      <button
        class="styled"
        :disabled="true"
        @click="cardsFormLinkAdd('facebook')"
      >
        + Ссылка на Facebook
      </button>
      <div class="social-link" v-if="valueLocal.instagram">
        <button class="remove-link" @click="cardsFormLinkRemove('instagram')">
          <i class="fal fa-times"></i>
        </button>
        Ссылка на Инстаграм:
        <input
          type="text"
          class="social-input"
          v-model="valueLocal.instagram.url"
          placeholder="https://instagram.com/..."
        />
      </div>
    </div>
    <div v-if="type == 'cards-form-shop-phone'" class="cards-form-shop-phone">
      <p-check
        class="p-switch p-fill"
        color="success"
        :true-value="true"
        :false-value="false"
        :disabled="disabled == 'true'"
        v-model="promoteInstallPhoneContact"
        @change="promoteInstallPhoneContactChange"
        >Предложить добавить Ваше заведение в список контактов?</p-check
      >
      <div v-if="promoteInstallPhoneContact" class="mt-2">
        Название контакта:
        <br />
        <input
          type="text"
          class="text-input mb-2"
          v-model="valueLocal.contact.name"
        />
        <br />
        Номер телефона:
        <br />
        <input
          type="text"
          class="text-input"
          v-model="valueLocal.contact.phone"
        />
      </div>
    </div>
    <div v-if="type == 'cards-push-recipients'" class="cards-push-recipients">
      <div class="btn-group">
        <button
          :class="{
            btn: true,
            'btn-secondary': true,
            active: valueLocal == 'all',
          }"
          @click="valueLocal = 'all'"
        >
          Всем
        </button>
        <button
          :class="{
            btn: true,
            'btn-secondary': true,
            active: valueLocal != 'all' && !valueLocal.includes('special-'),
          }"
          @click="valueLocal = CardsPushRecipients_cardNumber.toString()"
        >
          Карте
        </button>
        <button
          :class="{
            btn: true,
            'btn-secondary': true,
            active: valueLocal != 'all' && valueLocal.includes('special-'),
          }"
          @click="
            valueLocal = valueLocal =
              'special-' + CardsPushRecipients_sex + CardsPushRecipients_age
          "
        >
          Аудитории
        </button>
      </div>
      <div v-if="valueLocal == 'all'">Пуш будет отправлен всем гостям.</div>
      <div v-if="valueLocal != 'all' && !valueLocal.includes('special-')">
        Введите номер карты:
        <input
          type="number"
          v-model="CardsPushRecipients_cardNumber"
          @change="valueLocal = CardsPushRecipients_cardNumber.toString()"
        />
        <div
          class="alert alert-danger mt-2 mr-2"
          style="font-size: 10pt"
          role="alert"
          v-if="CardsPushRecipients_cardNumber == ''"
        >
          Введите номер карты или отправьте пуши
          <a
            style="color: white; margin-left: 0"
            href="#"
            @click="valueLocal = 'all'"
            >всем</a
          >
          картам.
        </div>
      </div>
      <div v-if="valueLocal != 'all' && valueLocal.includes('special-')">
        Выберите пол:
        <select
          v-model="CardsPushRecipients_sex"
          @change="
            valueLocal =
              'special-' + CardsPushRecipients_sex + CardsPushRecipients_age
          "
        >
          <option value="">всем</option>
          <option value="-sex:m">мужской</option>
          <option value="-sex:f">женский</option>
        </select>
        <br />
        Выберите возраст:
        <select
          v-model="CardsPushRecipients_age"
          @change="
            valueLocal =
              'special-' + CardsPushRecipients_sex + CardsPushRecipients_age
          "
        >
          <option value="">всем</option>
          <option value="-age:14_17">14-17</option>
          <option value="-age:18_24">18-24</option>
          <option value="-age:25_30">25-30</option>
          <option value="-age:31_41">31-41</option>
          <option value="-age:42_50">42-50</option>
          <option value="-age:50_70">50-70</option>
        </select>
        <div
          class="alert alert-danger mt-2 mr-2"
          style="font-size: 10pt"
          role="alert"
          v-if="!CardsPushRecipients_age && !CardsPushRecipients_sex"
        >
          Выберите хотя бы один критерий поиска аудитории или отправьте пуши
          <a
            style="color: white; margin-left: 0"
            href="#"
            @click="valueLocal = 'all'"
            >всем</a
          >
          картам.
        </div>
      </div>
    </div>
    <div v-if="type == 'cards-push-time-type'" class="cards-push-time-type">
      <p-radio
        class="p-default p-round p-smooth"
        color="primary"
        name="cards-push-time-type"
        v-model="valueLocal"
        :value="true"
        >Отправить пуши сейчас</p-radio
      >
      <br />
      <p-radio
        class="p-default p-round p-smooth"
        color="primary"
        name="cards-push-time-type"
        v-model="valueLocal"
        :value="false"
        >Выбрать дату и время</p-radio
      >
    </div>
    <div v-if="type == 'select'" class="select">
      <select
        class="form-control"
        :disabled="values.length == 0"
        v-model="valueLocal"
      >
        <option
          v-for="v of values"
          :key="v[valueKey || 'key']"
          :value="v[valueKey || 'key']"
        >
          {{ v[valueName || "value"] }}
        </option>
      </select>
    </div>
    <div v-if="type == 'checkbox'">
      <p-check
        class="p-switch p-fill"
        color="success"
        :true-value="1"
        false-value="0"
        :disabled="disabled == 'true'"
        v-model="valueLocal"
        >{{ label }}</p-check
      >
    </div>
    <div v-if="type == 'chatconnect-htmlcode'" class="chatconnect-htmlcode">
      <prism-editor
        :readonly="true"
        class="code"
        language="html"
        :code="`<!-- Вставьте этот код в head страницы -->\n<script src='//chatconnect.actid.ru/socket.io/socket.io.js' defer></script>\n<script id='chatconnectscript' src='//chatconnect.actid.ru/init.js' defer></script>\n\n<!-- Вставьте этот код в body страницы, в самый низ -->\n<div data-chatconnect='${valueLocal}'></div>`"
      ></prism-editor>
    </div>
    <div v-if="type == 'tags'">
      <vue-tags-input
        ref="type_tags"
        v-model="tag"
        :tags="valueLocal"
        :validation="[]"
        @tags-changed="(newTags) => (valueLocal = newTags.map((x) => x.text))"
        :placeholder="placeholder"
        :disabled="disabled == 'true'"
      />
    </div>
    <div v-if="type == 'hidden_key'" class="hidden_key">
      <i
        class="far fa-eye"
        v-if="!hide_hidden_key"
        @click="hide_hidden_key = !hide_hidden_key"
      ></i>
      <i
        class="far fa-eye-slash"
        v-else
        @click="hide_hidden_key = !hide_hidden_key"
      ></i>
      <span v-if="!hide_hidden_key">{{ valueLocal }}</span>
      <span v-else>{{ valueHidden }}</span>
    </div>
    <!--           -->

    <button
      v-if="plusButton"
      @click="plusButtonClick"
      class="styled plusButton"
    >
      <i style="margin: 0" class="fas fa-plus"></i>
    </button>

    <!--  -->
    <button
      v-if="saveButton"
      class="styled saveButton"
      @click="$emit('onSave', valueLocal)"
    >
      <i style="margin: 0" class="fal fa-save"></i>
    </button>
    <div v-if="about" class="about">{{ about }}</div>
    <div v-if="links.length != 0" class="links">
      <a
        class="link"
        :href="link.href"
        target="_blank"
        v-for="link in links"
        :key="link.href"
      >
        <i class="fas fa-cloud-download-alt"></i>
        <span>{{ link.text }}</span>
      </a>
    </div>
    <div v-if="placements.length != 0" class="placements">
      <div class="title">Персонализируйте сообщение:</div>
      <div
        class="placement"
        v-for="placement in placements"
        :key="placement.key"
      >
        <span class="key" @click="addPlacement(placement.value)">{{
          placement.value
        }}</span>
        — <span class="name">{{ placement.name }}</span>
      </div>
    </div>
    <!-- <div>value: {{value}}</div> -->
    <!-- <div>valueLocal: {{valueLocal}}</div> -->

    <modal
      :name="`geoMapPreview${geoFenceMapPreviewID}`"
      width="700"
      height="500"
      v-if="type == 'cards-geofences'"
    >
      <div class="geoMapPreview" style="height: 100%">
        <div :id="geoFenceMapPreviewID" style="height: 100%; width: 100%"></div>
      </div>
    </modal>

    <modal
      v-if="plusButtonPopup.title"
      :name="`plusButtonPopup` + uniq_id"
      height="auto"
      :adaptive="true"
    >
      <div class="close" @click="$modal.hide('plusButtonPopup' + uniq_id)">
        <i class="fal fa-times"></i>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>{{ plusButtonPopup.title }}</h2>
            <div class="content">
              <div
                class="inputModule"
                v-for="popup_input of plusButtonPopup.inputs"
                :key="`popup_input${popup_input.key}${uniq_id}`"
              >
                <input-module
                  :type="popup_input.type"
                  :title="popup_input.title"
                  v-model="plusButtonPopupData[popup_input.key]"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="text-right mt-2 mb-3">
              <button class="styled" @click="plusButtonSave">Создать</button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
let apiDriver = require("../apiDriver").default;
import PrismEditor from "vue-prism-editor";
import SmartTextbox from "./InputModule-textarea";
import DatePicker from "element-ui/lib/date-picker";
import TimePicker from "element-ui/lib/time-picker";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import InputModule from "./InputModule";

export default {
  components: {
    //   Prism
    PrismEditor,
    SmartTextbox,
    DatePicker,
    TimePicker,
    VueCtkDateTimePicker,
    InputModule,
  },
  name: "input-module",
  props: {
    type: {
      type: String,
      description: "Input type: text, image, number",
      default: "",
    },
    title: {
      type: String,
      description: "Input title",
      default: "",
    },
    value: {
      description: "Input model var",
      default: "",
    },
    about: {
      type: String,
      description: "About text",
      default: "",
    },
    values: {
      type: Array,
      description: "values for select element",
      default: () => [],
    },
    saveButton: {
      type: Boolean,
      default: false,
      description: "Display save button",
    },
    valueKey: { type: String, default: "" },
    valueName: { type: String, default: "" },
    label: { type: String, default: "" },
    disabled: { default: "" },
    layout: { default: "" },
    emojis: { default: false },
    placeholder: { default: "" },
    links: { default: () => [] },
    placements: { default: () => [] },
    collection: { default: () => [] },
    simple: { default: false },
    step: "",
    measure: "",
    plusButton: {
      type: Boolean,
      default: false,
    },
    plusButtonPopup: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    valueLocal: {
      get: function () {
        return this.value;
      },
      set: function (v) {
        this.$emit("change", v);
      },
    },
  },

  methods: {
    plusButtonSave(data) {
      this.$emit(
        "plusButtonSave",
        JSON.parse(JSON.stringify(this.plusButtonPopupData))
      );
      this.$modal.hide("plusButtonPopup" + this.uniq_id);
      let keys = Object.keys(this.plusButtonPopupData);
      for (let key of keys) this.plusButtonPopupData[key] = "";
    },
    plusButtonClick() {
      if (!this.plusButtonPopup.title) {
        console.log("inputModule emit: plusButtonClick");
        return this.$emit("plusButtonClick");
      } else {
        this.$modal.show(`plusButtonPopup${this.uniq_id}`);
      }
    },
    uploadImage() {
      this.$refs.fileUploadInput.click();
    },
    removeImage() {
      this.valueLocal = "";
    },
    async handleImageUpload(e) {
      if (this.loading) return;
      if (!e.target.files) return;
      if (e.target.files.length > 1) {
        this.$toast.error(`В это поле можно загрузить только 1 картинку.`);
        return;
      }
      let img = e.target.files[0];
      if (!img) return;
      if (!img.type.includes("image")) {
        this.$toast.error(`В это поле можно загрузить только картинку.`);
        return;
      }
      this.error = false;
      this.loading = true;
      let formData = new FormData();
      formData.append("file", img);
      let upload = await apiDriver.upload.image(formData);
      this.loading = false;
      if (!upload) {
        this.error = true;
        e.target.value = "";
        return;
      }
      this.valueLocal = upload.upload.Location;
      e.target.value = "";
    },

    //
    smsfeedbackQuestionAdd() {
      this.valueLocal.push({
        id: "_" + parseInt(Math.random() * 99999999),
        type: "option",
        value: ["Выбор 1", "Выбор 2"],
      });
    },
    smsfeedbackQuestionRemove(question) {
      let new_questions = this.valueLocal.filter((x) => x.id != question.id);
      this.valueLocal = new_questions;
    },
    smsfeedbackQuestionUpdateValue(question, i) {
      let x = prompt("Обновите текст значения:", question.value[i]);
      if (!x) return;
      question.value[i] = x;
      this.$forceUpdate();
    },
    smsfeedbackQuestionAddValue(question) {
      if (!question.value) question.value = [];
      question.value.push("Вариант ответа");
    },
    smsfeedbackQuestionRemoveValue(question, vi) {
      question.value = question.value.filter((x, i) => i != vi);
    },

    //
    geofenceAddMarker() {
      console.log("geofencesAddMarker!!");
      if (!this.valueLocal) this.valueLocal = [];
      if (this.valueLocal.length >= 10) return;
      this.valueLocal = [
        ...this.valueLocal,
        {
          latitude: "55.755495",
          longitude: "37.618785",
          relevantText: "Текст пуша",
        },
      ];
      this.$forceUpdate();
    },
    geofenceMoveMarker(e, i) {
      this.valueLocal[i].latitude = e.lat;
      this.valueLocal[i].longitude = e.lng;
    },
    geofenceMapCenterChanged(e) {
      this.gmapCenter.lat = e.lat();
      this.gmapCenter.lng = e.lng();
    },
    geofenceRemoveMarker(mi) {
      this.valueLocal = this.valueLocal.filter((x, i) => i != mi);
      this.$forceUpdate();
    },
    openGeoCollection() {
      this.showCollection = !this.showCollection;
      this.$forceUpdate();
    },
    addFromGeoCollection(el) {
      if (this.valueLocal.length >= 10) return;
      let a_h = document.body.scrollHeight;
      this.valueLocal.push(JSON.parse(JSON.stringify(el)));
      this.$forceUpdate();
      window.scrollTo({ top: window.scrollY + 116 }); //(document.body.scrollHeight-a_h)
    },
    geoUpdateMapPreview() {
      window["yMap_" + this.geoFenceMapPreviewID] = new window.ymaps.Map(
        this.geoFenceMapPreviewID,
        {
          center: [55.76, 37.64],
          zoom: 10,
        }
      );
      let geos = this.valueLocal;
      window["yMap_" + this.geoFenceMapPreviewID].geoObjects.removeAll();
      for (let geo of geos) {
        let myCircle = new window.ymaps.Circle(
          [
            [Number(geo.latitude), Number(geo.longitude)], // Координаты центра круга.
            100, // Радиус круга в метрах.
          ],
          {},
          {
            draggable: false, // Задаем опции круга. Включаем возможность перетаскивания круга.
            fillColor: "#DB709377",
            strokeColor: "#990066",
            strokeOpacity: 0.8,
            strokeWidth: 1,
          }
        );

        let myGeoObject = new window.ymaps.GeoObject(
          {
            geometry: {
              type: "Point",
              coordinates: [Number(geo.latitude), Number(geo.longitude)],
            },
            properties: {
              iconContent: geo.relevantText,
            },
          },
          {
            preset: "islands#blackStretchyIcon",
            draggable: true,
          }
        );

        myGeoObject.events.add(["dragend"], (e) => {
          myCircle.geometry.setCoordinates(
            e.get("target").geometry.getCoordinates()
          );
          geo.latitude = e
            .get("target")
            .geometry.getCoordinates()[0]
            .toFixed(6);
          geo.longitude = e
            .get("target")
            .geometry.getCoordinates()[1]
            .toFixed(6);
        });

        // Добавляем круг на карту.
        window["yMap_" + this.geoFenceMapPreviewID].geoObjects.add(myCircle);
        window["yMap_" + this.geoFenceMapPreviewID].geoObjects.add(myGeoObject);
        // window["yMap_"+this.geoFenceMapPreviewID].geoObjects.add(myBalloon);
      }
      window["yMap_" + this.geoFenceMapPreviewID].setBounds(
        window["yMap_" + this.geoFenceMapPreviewID].geoObjects.getBounds()
      );
    },
    async openGeoFenceMapPreview() {
      await this.$modal.show("geoMapPreview" + this.geoFenceMapPreviewID);
      setTimeout(this.geoUpdateMapPreview, 500);
    },
    geoFenceLocationChanged(key, v) {
      let coord = v[key];
      if (!coord.includes(", ")) {
        if (coord.includes(",")) v[key] = coord.replace(",", ".");
        return;
      }
      v.latitude = coord.split(", ")[0].replace(/\s/g, "");
      v.longitude = coord.split(", ")[1].replace(/\s/g, "");
    },

    //
    cardsContentRemoveField(field) {
      if (!field) return;
      this.valueLocal = this.valueLocal.filter((x) => x.key != field.key);
    },
    cardsContentAddField() {
      this.valueLocal.push({
        key: "_field" + (Math.random() * 99999999).toString(),
        label: "Название поля",
        value: "",
      });
      //move last_message to the end:
      let last_message = this.valueLocal.find((x) => x.key == "last_message");
      if (!last_message) {
        last_message = {
          key: "last_message",
          label: "Последнее уведомление",
          value: "",
          changeMessage: "%@",
        };
      }
      let lstmsg = JSON.parse(JSON.stringify(last_message));
      console.log("lstmsg:", lstmsg);
      let new_valueLocal = [];
      for (let x of this.valueLocal) {
        if (x.key != "last_message") new_valueLocal.push(x);
      }
      new_valueLocal.push(lstmsg);
      console.log("new_valueLocal:", new_valueLocal);
      this.valueLocal = new_valueLocal;
      console.log("this.valueLocal:", this.valueLocal);
    },
    cardsFormLinkAdd(type) {
      this.valueLocal[type] = { url: "" };
      this.$forceUpdate();
    },
    cardsFormLinkRemove(type) {
      delete this.valueLocal[type];
      this.$forceUpdate();
    },
    emojiPickerToggle() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    emojiPickerSelect(emoji) {
      if (this.inputCaretPosition == 0)
        return (this.valueLocal = emoji.data + this.valueLocal);
      console.log(this.inputCaretPosition);
      console.log(this.valueLocal.length);
      let p1 = this.valueLocal.slice(0, this.inputCaretPosition);
      let p2 = this.valueLocal.slice(
        -1 * (this.valueLocal.length - this.inputCaretPosition)
      );
      this.valueLocal =
        p1 + emoji.data + (p2.length == this.valueLocal.length ? "" : p2);
      //"Буквально 2-3 минуты".slice(0, 10)
      //+"Буквально 2-3 минуты".slice("Буквально 2-3 минуты".length-10)
    },
    inputEvent(e) {
      setTimeout(() => {
        this.inputCaretPosition = e.target.selectionStart;
      }, 100);
    },

    //
    cardContentFields(o) {
      let keys = this.cardContentKeys;
      let name = o.key;
      if (o.key.slice(0, 6) == "spacer") name = "Пустое место";
      return (
        keys[o.key] || {
          name,
          key: o.key,
          default_label: o.label,
          example_value: o.value,
        }
      );
    },
    removeSelectedField() {
      let o =
        this.valueLocal[this.cardContentSelectedField.from][
          this.cardContentSelectedField.i
        ];
      o.key = "spacer_" + parseInt(Math.random() * 9999999);
      o.label = "";
      o.value = "";
      delete o.changeMessage;
      delete o.textAlignment;
      this.cardContentSelectedField.show = false;
    },
    openFieldDetails(i, from) {
      let d = this.cardContentFields(this.valueLocal[from][i]);
      this.cardContentSelectedField.i = i;
      this.cardContentSelectedField.from = from;
      this.cardContentSelectedField.key = d.key;
      this.cardContentSelectedField.value = this.valueLocal[from][i].value;
      this.cardContentSelectedField.name = d.name;
      this.cardContentSelectedField.default_label = d.default_label;
      this.cardContentSelectedField.example_value = d.example_value;
      if (d.changeMessage) {
        this.cardContentSelectedField.changeMessageEnabled = true;
        this.cardContentSelectedField.changeMessage = d.changeMessage;
      } else {
        this.cardContentSelectedField.changeMessageEnabled = false;
        this.cardContentSelectedField.changeMessage = "";
      }
      if (d.key.slice(0, 6) == "spacer") {
        this.openCardContentMarket(i, from);
      } else {
        this.cardContentSelectedField.show = true;
        this.cardContentMarket.show = false;
      }
    },
    openCardContentMarket(place_i, from) {
      this.cardContentMarket.show = true;
      this.cardContentSelectedField.show = false;
      this.cardContentMarket.place_i = place_i;
      this.cardContentMarket.from = from;
    },
    cardContentAddField(key) {
      this.cardContentMarket.show = false;
      let place_i = this.cardContentMarket.place_i;
      let from = this.cardContentMarket.from;
      let d = this.cardContentFields({ key });

      let o = {
        key,
        label: d.default_label,
        value: "",
      };
      if (d.changeMessage) o.changeMessage = d.changeMessage;

      if (from == "headerFields") {
        o.textAlignment = "PKTextAlignmentRight";
        this.valueLocal[from] = [o];
        this.openFieldDetails(0, "headerFields");
      } else if (from == "primaryFields") {
        o.textAlignment = "PKTextAlignmentLeft";
        this.valueLocal[from] = [o];
        this.openFieldDetails(0, "primaryFields");
      } else if (from == "secondaryFields") {
        // secondaryFields
        if (this.cardContentSelectedField.key.slice(0, 6) == "spacer") {
          let textAlignment = "PKTextAlignmentLeft";
          if (this.cardContentSelectedField.i == 1)
            textAlignment = "PKTextAlignmentCenter";
          if (this.cardContentSelectedField.i == 2)
            textAlignment = "PKTextAlignmentRight";
          o.textAlignment = textAlignment;
          this.valueLocal[from][this.cardContentSelectedField.i] = o;
          console.log(o, JSON.parse(JSON.stringify(this.valueLocal[from])));
          this.openFieldDetails(
            this.cardContentSelectedField.i,
            "secondaryFields"
          );
        } else {
          if (this.valueLocal[from].length == 0) {
            if (place_i == 1)
              this.valueLocal[from].push({
                key: "spacer_" + parseInt(Math.random() * 9999999),
                label: "",
                value: "",
              });
            if (place_i == 2)
              this.valueLocal[from].push(
                {
                  key: "spacer_" + parseInt(Math.random() * 9999999),
                  label: "",
                  value: "",
                },
                {
                  key: "spacer_" + parseInt(Math.random() * 9999999),
                  label: "",
                  value: "",
                }
              );
            let p = this.valueLocal[from].push(o);
            if (place_i == 1)
              this.valueLocal[from].push({
                key: "spacer_" + parseInt(Math.random() * 9999999),
                label: "",
                value: "",
              });
            this.openFieldDetails(p, "secondaryFields");
          } else if (this.valueLocal[from].length == 1) {
            if (place_i == 2)
              this.valueLocal[from].push({
                key: "spacer_" + parseInt(Math.random() * 9999999),
                label: "",
                value: "",
              });
            let p = this.valueLocal[from].push(o);
            if (place_i == 1)
              this.valueLocal[from].push({
                key: "spacer_" + parseInt(Math.random() * 9999999),
                label: "",
                value: "",
              });
            this.openFieldDetails(p, "secondaryFields");
          } else if (this.valueLocal[from].length == 2) {
            let p = this.valueLocal[from].push(o);
            this.openFieldDetails(p, "secondaryFields");
          }
        }
      }
    },

    //
    addPlacement(key) {
      this.valueLocal += key;
    },

    focus() {
      if (this.type == "text") this.$refs.type_text.focus();
      if (this.type == "number") this.$refs.type_number.focus();
      if (this.type == "number-change-show")
        this.$refs.type_number - change - show.focus();
    },

    promoteInstallPhoneContactChange() {
      if (this.promoteInstallPhoneContact) {
        this.valueLocal.contact = {
          phone: "",
          name: "",
        };
      } else {
        delete this.valueLocal.contact;
      }
      this.$forceUpdate();
      console.log(
        "promoteInstallPhoneContactChange",
        this.promoteInstallPhoneContact,
        this.valueLocal
      );
    },
  },

  mounted() {
    //   this.valueLocal = this.value;
    this.initValueLocal = this.valueLocal;
    if (!this.valueLocal && this.type == "cards-geofences")
      this.valueLocal = [];
    if (this.type == "image") {
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop",
      ].forEach(
        function (evt) {
          this.$refs.imageFileForm.addEventListener(
            evt,
            function (e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      this.$refs.imageFileForm.addEventListener(
        "drop",
        function (e) {
          this.$refs.fileUploadInput.files = e.dataTransfer.files;
          this.handleImageUpload({ target: this.$refs.fileUploadInput });
        }.bind(this)
      );
    }
    if (this.type == "hidden_key") {
      this.valueHidden = "X".repeat(this.valueLocal.length);
    }
    // if( this.type == "number" ){
    //     this.valueLocal = this.valueLocal.replace(/\,/g, '.');
    // }
    if (this.type == "cards-geofences") {
      // { "latitude": 55.700568, "longitude": 37.839058, "relevantText": "Спасибо, что ты с нами! 😏 Приятного отдыха" }
      if (this.valueLocal[0])
        this.orig_gmapCenter = {
          lat: this.valueLocal[0].latitude,
          lng: this.valueLocal[0].longitude,
        };
    }
    if (this.type == "cards-content-secondary") {
      if (!this.valueLocal.primaryFields) {
        this.valueLocal.primaryFields = [];
        this.$forceUpdate();
      }
      if (this.valueLocal.primaryFields.length == 0) {
        this.valueLocal.primaryFields = [
          {
            key: "spacer_" + parseInt(Math.random() * 9999999),
            label: "",
            value: "",
          },
        ];
      }
      if (this.valueLocal.secondaryFields.length == 0) {
        this.valueLocal.secondaryFields = [
          {
            key: "spacer_" + parseInt(Math.random() * 9999999),
            label: "",
            value: "",
          },
          {
            key: "spacer_" + parseInt(Math.random() * 9999999),
            label: "",
            value: "",
          },
          {
            key: "spacer_" + parseInt(Math.random() * 9999999),
            label: "",
            value: "",
          },
        ];
      }
      if (this.valueLocal.secondaryFields.length == 1) {
        this.valueLocal.secondaryFields.push(
          {
            key: "spacer_" + parseInt(Math.random() * 9999999),
            label: "",
            value: "",
          },
          {
            key: "spacer_" + parseInt(Math.random() * 9999999),
            label: "",
            value: "",
          }
        );
      }
      if (this.valueLocal.secondaryFields.length == 2) {
        this.valueLocal.secondaryFields = [
          this.valueLocal.secondaryFields[0],
          {
            key: "spacer_" + parseInt(Math.random() * 9999999),
            label: "",
            value: "",
          },
          this.valueLocal.secondaryFields[1],
        ];
      }
    }
    // for(let x of this.valueLocal) this.gmapsValues.push({lat: x[0], lng: x[1]});

    if (this.type == "cards-form-shop-phone") {
      if (this.valueLocal.contact) this.promoteInstallPhoneContact = true;
    }
  },

  data() {
    return {
      plusButtonPopupData: {},
      uniq_id: Math.random(),
      tag: "",
      error: false,
      loading: false,
      orig_gmapCenter: { lat: 55.755495, lng: 37.618785 },
      gmapCenter: { lat: 55.755495, lng: 37.618785 },
      default_text: ["Здесь отображаются новости-пуши у гостей."],
      showEmojiPicker: false,
      inputCaretPosition: 0,
      cardContentSelectedField: {
        from: "",
        i: 0,
        key: "",
        value: "",
        name: "",
        default_label: "",
        example_value: "",
        changeMessageEnabled: false,
        changeMessage: "",
        show: false,
      },
      cardContentKeys: {
        card_number: {
          name: "Номер карты",
          key: "card_number",
          default_label: "Карта",
          example_value: "777",
        },
        name: {
          name: "Имя и фамилия гостя",
          key: "name",
          default_label: "Любимый гость",
          example_value: "Илон Маск",
        },
        firstname: {
          name: "Имя гостя",
          key: "firstname",
          default_label: "Любимый гость",
          example_value: "Илон",
        },
        lastname: {
          name: "Фамилия гостя",
          key: "lastname",
          default_label: "Любимый гость",
          example_value: "Маск",
        },
        bonus: {
          name: "Количество бонусов",
          key: "bonus",
          default_label: "Бонусы",
          example_value: "1322",
          changeMessage: "Спасибо за визит 😉 Бонусный счёт: %@",
        },
        discount: {
          name: "Размер скидки",
          key: "discount",
          default_label: "Скидка",
          example_value: "5%",
        },
        cashback: {
          name: "Размер кешбека",
          key: "cashback",
          default_label: "Кешбек",
          example_value: "5%",
        },
      },
      cardContentMarket: {
        show: false,
        place_i: 0,
        from: "",
      },
      showCollection: false,
      lookGeoFences: false,
      geoFenceMapPreviewID: "map_" + parseInt(Math.random() * 9999999),
      initValueLocal: undefined,
      valueHidden: "",
      hide_hidden_key: true,
      CardsPushRecipients_cardNumber: "",
      CardsPushRecipients_sex: "",
      CardsPushRecipients_age: "",
      promoteInstallPhoneContact: false,
      // emojiPack: packData
      // ym_settings: {apiKey: '694d52dc-b141-406e-9c72-2ce1a3cf1841', version: '2.1'},
      // gmapsValues: []
    };
  },
};
</script>
<style scoped lang="stylus">
.vue-tags-input {
  width: calc(100% - 15px);
  max-width: none;
}

.input-module {
  border-left: 4px solid #ede7f6;
  padding-left: 15px;
  padding-bottom: 5px;
  margin-left: 10px;
  width: 100%;
  position: relative;

  &:hover {
    border-left: 4px solid #673ab7;
  }

  &.error {
    border-color: red;
  }

  &.disabled {
    opacity: 0.5;
    border-left: 4px solid #ececec;
  }

  .title {
    cursor: default;
    font-weight: 300;
    margin-bottom: 2px;
  }

  .about {
    color: #b5b5b5;
    font-size: 10pt;
    margin-top: 5px;
    cursor: default;
  }

  .links {
    .link {
      color: black;
      font-size: 8pt;
      text-decoration: none;
      text-transform: uppercase;
      display: block;
      opacity: 0.4;
      font-weight: 600;

      i {
        margin-right: 5px;
      }

      &:hover {
        opacity: 1;
        color: #3e9edd;
      }
    }
  }

  .placements {
    border-left: 1px solid #eee;
    padding-top: 3px;
    padding-left: 5px;
    font-size: 9pt;
    margin-left: 10px;

    .title {
      font-weight: bold;
    }

    .placement {
      position: relative;

      .key {
        font-weight: 600;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      .name {
        cursor: default;
      }
    }
  }

  &.simple {
    border: none;
    padding: 0;
    width: fit-content;
    margin-left: 0;
  }

  &.plusButton {
    width: calc(100% - 36px);
  }

  &.saveButton {
    width: calc(100% - 32px);
  }
}

.unavailable_on_mobile {
  display: none;
  color: #F44336;
}

.image-input-holder {
  .input-module-hidden-input {
    visibility: none;
    position: fixed;
    top: -1000px;
    left: -1000px;
  }

  .image-input {
    height: 70px;
    border: 1px solid #eee;
    width: 250px;

    &[layout='square'] {
      width: 70px;
    }

    &[layout='big'] {
      height: 200px;
    }
  }

  .uploadButton {
    margin-left: 10px;
  }

  .remove_image {
    border: none;
    background: white;
    text-align: center;
    color: #adadad;
    margin-top: 2px;
    font-size: 10px;
    outline: none;
    margin-left: 5px;

    &:hover {
      color: black;
    }
  }

  .transparency {
    background: url('/assets/actid/transparency.png');
    background-size: 230px;
    width: fit-content;
  }
}

.text-input, .number-input {
  width: calc(100% - 15px);
  padding: 3px 10px;
  border: 1px solid #eee;
  outline: none;

  &:focus {
    border-color: #b39ddb;
  }
}

.title-text {
  input {
    font-size: 17pt;
    border: none;
    // border-bottom: 1px solid #eee;
    padding-top: 0;
    padding: 0;
  }
}

.link {
  input {
    width: calc(100% - 15px);
    padding: 3px 10px;
    border: 1px solid #eee;
    outline: none;

    &:focus {
      border-color: #b39ddb;
    }
  }
}

.color_holder {
  border: 1px solid #eee;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  padding-top: 2px;
}

.smsfeedback-questions {
  .question-add {
    margin-top: 10px;
  }

  .question {
    position: relative;
    margin-left: 15px;
    border-left: 2px solid #ede7f6;
    padding-left: 15px;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-top: 5px;
    padding-bottom: 5px;

    &:hover {
      border-left: 2px solid #673ab7;
    }

    .question-title {
      width: calc(100% - 15px);
      outline: none;
      margin-bottom: 10px;
      font-size: 12pt;
      border: none;
      border-bottom: 1px solid #eee;
      font-weight: bold;

      &:hover, &:focus {
        border-bottom: 1px solid gray;
      }
    }

    .remove-question {
      position: absolute;
      top: 0;
      left: -26px;
      background: none;
      border: none;
      opacity: 0.5;
      cursor: pointer;
      outline: none;

      &:hover {
        opacity: 1;
      }
    }

    .value-holder {
      position: relative;
      margin-left: 20px;

      .add_value {
        position: absolute;
        top: -4px;
        left: -26px;
        background: none;
        border: none;
        opacity: 0.5;
        cursor: pointer;
        outline: none;

        &:hover {
          opacity: 1;
        }
      }

      .remove-value {
        background: none;
        border: none;
        opacity: 0.5;
        cursor: pointer;
        outline: none;

        &:hover {
          opacity: 1;
        }
      }

      .question-value {
        padding: 2px 5px;
        margin-top: 2px;
        border-radius: 4px;

        &:hover {
          background: #f3f3f3;
        }

        span {
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  select {
    width: calc(100% - 15px);
  }

  .value-header {
    font-size: 8pt;
    font-weight: bold;
    margin-top: 5px;
  }
}

.cards-geofences {
  position: relative;

  .ymap-container, .gmaps-map {
    height: 300px;
    margin-bottom: 15px;
  }

  .geofences-addpoint {
    position: absolute;
    border: 1px solid #6c68cb;
    padding: 10px 15px;
    border-radius: 0px 0px 4px 0px;
    color: #464384;
    cursor: pointer;
    background: white;
    outline: none;
    z-index: 2;

    &:hover {
      background: #6c68cb;
      color: white;
    }

    &[disabled] {
      color: gray;
      cursor: default;
      border-color: #eee;
      background: white;
    }
  }

  .geofences-addpoint-withoutmap {
    border: 1px solid #6c68cb;
    padding: 10px 15px;
    border-radius: 4px;
    color: #464384;
    cursor: pointer;
    background: white;
    outline: none;
    z-index: 2;

    &:hover {
      background: #6c68cb;
      color: white;
    }

    &[disabled] {
      color: gray;
      cursor: default;
      border-color: #eee;
      background: white;
    }
  }

  .point {
    position: relative;
    margin-left: 15px;
    border-left: 2px solid #ede7f6;
    padding-left: 15px;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-top: 0px;
    padding-bottom: 0px;

    &:hover {
      border-left: 2px solid #673ab7;
    }

    .remove_point {
      position: absolute;
      top: 0;
      left: -26px;
      background: none;
      border: none;
      opacity: 0.5;
      cursor: pointer;
      outline: none;

      &:hover {
        opacity: 1;
      }
    }

    .point_title {
    }

    .point-text {
      width: calc(100% - 15px);
      outline: none;
      margin-bottom: 10px;
      font-size: 12pt;
      border: none;
      border-bottom: 1px solid #eee;
      font-weight: bold;

      &:hover, &:focus {
        border-bottom: 1px solid gray;
      }
    }

    .point-nav {
      width: 100%;
      outline: none;
      font-size: 10pt;
      border: none;
      border-bottom: 1px solid #eee;
      margin-bottom: 10px;

      &:hover, &:focus {
        border-bottom: 1px solid gray;
      }
    }
  }

  .collection_toggle {
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }

    &.showing {
      color: #4CAF50;
    }

    i {
      margin-right: 5px;
    }
  }

  .lookGeoFences {
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }

    &.showing {
      color: #4CAF50;
    }
  }

  .collection {
    background: #fff;
    color: black;
    position: absolute;
    right: -230px;
    box-shadow: 0 20px 20px rgba(0, 0, 0, 0.1);
    z-index: 2;
    border: 1px solid #eee;
    border-radius: 10px;
    bottom: -90px;
    width: 230px;

    .title {
      text-align: center;
      margin-top: 5px;
    }

    .close {
      position: absolute;
      top: 5px;
      right: 10px;
    }

    .elList {
      overflow: hidden;
      overflow-y: scroll;
      height: 350px;
      margin-top: 5px;
    }

    .el {
      padding: 5px 10px;
      width: 220px;
      cursor: pointer;
      margin: 2px;
      border-radius: 10px;

      &:hover {
        background: #eee;
      }

      .coordinate {
        margin-right: 5px;
        font-size: 8pt;
        opacity: 0.5;
      }

      &.used {
        cursor: default;
        background: white;
        position: relative;

        .text {
          opacity: 0.5;
        }

        .coordinate {
          opacity: 0.5;
        }

        &:after {
          color: #4caf50;
          padding: 3px 6px;
          font-size: 8pt;
          border-radius: 4px;
          display: inline-block;
          position: absolute;
          bottom: 4px;
          content: 'Используется';
        }
      }
    }
  }
}

.cards-content {
  .field {
    position: relative;
    margin-left: 15px;
    border-left: 2px solid #ede7f6;
    padding-left: 15px;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-top: 0px;
    padding-bottom: 0px;

    &:hover {
      border-left: 2px solid #673ab7;
    }

    .remove-field {
      position: absolute;
      top: 0;
      left: -26px;
      background: none;
      border: none;
      opacity: 0.5;
      cursor: pointer;
      outline: none;

      &:hover {
        opacity: 1;
      }

      &[disabled] {
        opacity: 0.2;
        cursor: default;
      }
    }

    .field-label {
      width: calc(100% - 15px);
      outline: none;
      margin-bottom: 10px;
      font-size: 12pt;
      border: none;
      border-bottom: 1px solid #eee;
      font-weight: bold;

      &:hover, &:focus {
        border-bottom: 1px solid gray;
      }
    }

    .field-value {
      width: calc(100% - 15px);
      border: 1px solid rgb(238, 238, 238);
      box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 10px;
      border-radius: 4px;
      margin-top: 0px;
      margin-bottom: 0px;
      height: 55px;
      outline: none;
      padding: 5px 10px;

      &:hover, &:focus {
        border: 1px solid gray;
      }

      &[disabled] {
        background: #f7f7f7;
        box-shadow: none;
        border: none;
      }
    }
  }
}

.cards-content-secondary {
  .key {
    font-size: 6pt;
    text-transform: uppercase;
    margin-bottom: -5px;
  }

  .value {
    &.big {
      font-size: 14pt;
      font-weight: 600;
      margin-top: -5px;
      margin-bottom: -5px;
    }
  }

  .blank {
    height: 60px;
    width: 100%;
    background: #eee;
    border-radius: 15px;
    overflow: hidden;

    span {
      display: block;
      text-align: center;
      font-size: 7pt;
      text-transform: uppercase;
      margin-top: 23px;
      font-weight: 800;
      color: #cecece;
    }
  }

  .add_field {
    height: 60px;
    width: 130px;
    background: #eee;
    border-radius: 15px;
    cursor: pointer;
    overflow: hidden;

    i {
      display: block;
      text-align: center;
      margin-top: 15px;
    }

    span {
      display: block;
      text-align: center;
      font-size: 7pt;
      text-transform: uppercase;
      margin-top: 5px;
    }

    &:hover {
      background: #dcdcdc;
    }
  }

  .current_field {
    height: 60px;
    width: 130px;
    background: #eee;
    border-radius: 15px;
    cursor: pointer;
    overflow: hidden;
    padding: 10px;
    padding-top: 17px;

    &:hover {
      background: #dcdcdc;
    }

    .add_field {
      height: unset;
      width: unset;
      background: none;
      border-radius: 0;
      position: relative;
      top: -17px;
    }
  }

  .element_editor {
    background: #fff;
    color: black;
    position: absolute;
    right: -245px;
    top: 10px;
    box-shadow: 0 20px 20px rgba(0, 0, 0, 0.1);
    z-index: 2;
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 10px 20px;
    width: 250px;

    .changeMessage {
      margin-top: 15px;

      .tip {
        font-size: 8pt;
        opacity: 0.5;
        margin-bottom: 5px;
        transition: 0.3s all;

        &:hover {
          font-size: 10pt;
          opacity: 1;
        }
      }
    }

    .remove {
      margin-top: 15px;
      width: 100%;
      outline: none;
      background: white;
      border: 1px solid;
      border-radius: 4px;
      padding: 5px 0;
      color: #f44336;

      &:hover {
        background: #f44336;
        color: white;
      }
    }
  }

  .element_market {
    background: #fff;
    color: black;
    position: absolute;
    right: -245px;
    top: 10px;
    box-shadow: 0 20px 20px rgba(0, 0, 0, 0.1);
    z-index: 2;
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 10px 20px;
    width: 250px;

    .close {
      position: relative;
      z-index: 2;
    }

    .element {
      cursor: pointer;
      padding: 1px 10px;
      padding-bottom: 10px;
      border-radius: 4px;
      position: relative;

      i {
        position: absolute;
        left: -10px;
        top: 13px;
        opacity: 0.4;
      }

      &:hover {
        background: #eee;

        i {
          opacity: 1;
          color: #4CAF50;
        }
      }
    }
  }
}

.code {
  width: calc(100% - 15px);
}

.cards-form-links {
  .social-link {
    position: relative;
    margin-left: 15px;
    border-left: 2px solid #ede7f6;
    padding-left: 15px;
    margin-top: 10px;
    padding-top: 0px;
    padding-bottom: 0px;

    &:hover {
      border-left: 2px solid #673ab7;
    }

    .remove-link {
      position: absolute;
      top: 0;
      left: -26px;
      background: none;
      border: none;
      opacity: 0.5;
      cursor: pointer;
      outline: none;

      &:hover {
        opacity: 1;
      }

      &[disabled] {
        opacity: 0.2;
        cursor: default;
      }
    }

    .social-input {
      width: calc(100% - 15px);
      padding: 3px 10px;
      border: 1px solid #eee;
      outline: none;

      &:focus {
        border-color: #b39ddb;
      }
    }
  }
}

.number-change-show-holder {
  .change {
    position: absolute;
    top: 27px;
    right: 25px;
    background: white;
    color: #f44336;
    cursor: default;
    min-width: 20px;
    text-align: right;

    &.positive {
      color: #8bc34a;
    }
  }
}

.select {
  select {
    width: calc(100% - 15px);
  }
}

.emojipicker {
  position: absolute;
  margin-left: -325px;
  margin-top: 5px;
  right: 15px;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.1);
  z-index: 2;

  &.hidden {
    display: none;
  }
}

.toggle_emoji_picker {
  position: absolute;
  right: 23px;
  top: 27px;
  cursor: pointer;
  opacity: 0.4;

  &:hover {
    opacity: 1;
  }

  &.openned {
    color: #4caf50;
    opacity: 1;
  }
}

@media only screen and (max-width: 600px) {
  .unavailable_on_mobile {
    display: block;
  }

  .toggle_emoji_picker {
    display: none !important;
  }

  .image-input-holder {
    table {
      td {
        display: block;
      }
    }

    .uploadButton {
      margin-left: 0;
      margin-top: 10px;
    }

    .remove_image {
      margin-left: 0;
      margin-top: 5px;
    }
  }

  .cards-content-secondary {
    table {
      display: none;
    }
  }

  .cards-geofences {
    .collection_toggle {
      display: block;
      margin-top: 10px;
    }

    .lookGeoFences {
      display: block;
      margin-top: 5px;
    }

    .collection {
      bottom: -330px;
      right: unset;
      left: 50%;
      transform: translateX(-50%);
      width: 340px;
      margin-left: -20px;
    }
  }
}

.cards-form-shop-phone {
  .text-input {
    width: calc(100% - 15px);
    padding: 3px 10px;
    border: 1px solid #eee;
    outline: none;
  }
}

.hidden_key {
  border-radius: 5px;
  font-family: monospace;
  word-break: break-all;
  padding-top: 5px;

  i {
    margin-right: 10px;
    cursor: pointer;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
}

button.plusButton {
  position: absolute;
  right: -22px;
  top: 23px;
  padding: 2px 8px;
  height: calc(100% - 28px);
}

button.saveButton {
  position: absolute;
  right: -18px;
  top: 23px;
  padding: 2px 8px;
  height: 29px;
}

@media (prefers-color-scheme: dark) {
  .input-module {
    border-left: 4px solid #383838;

    &.disabled {
      border-left: 4px solid #2a2a2a;
    }
  }

  .image-input-holder .remove_image {
    background: unset;

    &:hover {
      color: white;
    }
  }

  .text-input, .number-input, .select select, .link input, .cards-geofences .point .point-text, .cards-geofences .point .point-nav, .cards-form-links .social-link .social-input, .cards-form-shop-phone .text-input {
    background: #1e1e1e;
    color: white;
    border-color: #444444;

    &:focus {
      border-color: #b39ddb;
    }
  }

  .title-text input {
    background: unset;
  }

  .cards-form-links .social-link .remove-link {
    color: white;
  }

  .cards-form-links .social-link {
    border-color: #383838;
  }

  .cards-content-secondary .blank {
    background: #282828;
  }

  .cards-content-secondary .current_field {
    background: #282828;

    &:hover {
      background: #383838;
    }
  }

  .cards-content .field .field-label {
    background: unset;
    color: white;
  }

  .cards-content .field, .cards-geofences .point {
    border-color: #383838;
  }

  .cards-geofences .geofences-addpoint-withoutmap {
    border: 1px solid #b0adff;
    color: white;
    background: #6c68cb;

    &:hover {
      background: #6c68cb;
      color: white;
    }

    &[disabled] {
      color: #808080;
      border-color: #3c3c3c;
      background: #161616;
    }
  }

  .cards-geofences .point .remove_point {
    color: white;
  }

  .cards-content .field .remove-field {
    color: white;
  }

  .input-module .links .link {
    color: #fff;
  }

  .input-module .placements {
    border-color: #6a6a6a;
  }
}
</style>